<template>
    <div>
      <div class="top_image_container">
        <div class="background_image_container w-full">
          <img src="img/profile-background.jpg" class="background_img w-full">
        </div>
        <div class="flex flex-col items-center mt-negative20">
          <img src="img/estudanteImagem.jpg" class="w40 border4 border-white rounded-full">   
          <PesquisarEstudante @estudanteEscolhido="PesquisaLocal" :redColorActive="false"/>
        </div>
      </div>
      <div style="margin-top: 15px; background-color: #fff;">
        <ListarRegistros ref="listarRegistros" v-if="estudante_" :estudante="estudante_" ></ListarRegistros>
      </div>
    </div>
  </template>
  
  <script>
  import PesquisarEstudante from "@/components/estudantes/PesquisarEstudante.vue";
  import ListarRegistros from '../../components/funcionario/ListarRegistrosEstudante.vue';
  
  export default {
    components: {
      PesquisarEstudante,
      ListarRegistros
    },
    data() {
      return {
        estudante_: null
      };
    },
    methods: {
      PesquisaLocal(estudante) {
        // Limpar estudante_ para forçar atualização de dados
        this.estudante_ = null;
  
        // Pequeno delay para garantir reatividade correta antes de atualizar estudante_
        setTimeout(() => {
          this.estudante_ = estudante;
        }, 100);
      }
    }
  };
  </script>
  
  <style scoped>
  .top_image_container {
    background-color: #fff;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    padding-bottom: 1rem;
  }
  .background_image_container {
    height: 150px;
  }
  .background_image_container .background_img {
    height: 100%;
  }
  .w-full {
    width: 100%;
  }
  .flex {
    display: flex;
  }
  .flex-col {
    flex-direction: column;
  }
  .items-center {
    align-items: center;
  }
  .mt-negative20 {
    margin-top: -100px;
  }
  
  .w40 {
    width: 10rem;
  }
  
  .border4 {
    border-width: 0.25rem;
  }
  
  .border-white {
    border-color: #fff;
  }
  .rounded-full {
    border-radius: 50%;
  }
  </style>
  